"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BsRsvGallery = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const gallery_slider_1 = require("./gallery-slider");
const bs_rsv_gallery_styles_1 = require("./bs-rsv-gallery.styles");
function getPreviewItem(_a = {}) {
    var { preview } = _a, item = __rest(_a, ["preview"]);
    if (preview)
        return Object.assign(Object.assign({}, item), { image: preview });
    return item;
}
function BsRsvGallery(props) {
    const { items, initialSlide: originalInitialSlide = 0, slideInfo, overlaySlideInfo, setCurrentItem, initialOverlayStatus = false, previewIconName = `preview-icon`, leftArrow, rightArrow, afterOverlayOpen, renderSlide, showNavigationForOneItem = false, } = props;
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const [isOverlayShown, openOverlay, closeOverlay] = (0, libs_hooks_react_1.useToggleState)(initialOverlayStatus);
    const [initialSlide, setInitialSlide] = (0, react_1.useState)(originalInitialSlide);
    const isHideNavigation = items.length === 1 && !showNavigationForOneItem;
    const handleOpenOverlay = () => {
        openOverlay();
        afterOverlayOpen && afterOverlayOpen();
    };
    const images = (0, react_1.useMemo)(() => {
        return items
            .map((item, index) => (Object.assign(Object.assign({}, item), { mapIndex: index })))
            .filter(i => i.__typename === 'ImageMediaItem');
    }, [items]);
    const renderSlideInfo = (0, react_1.useCallback)(slide => {
        return (items[slide] && (react_1.default.createElement(react_1.default.Fragment, null,
            slideInfo &&
                slideInfo(items[slide], slide, items.length, isHideNavigation),
            items[slide].__typename === 'ImageMediaItem' && (react_1.default.createElement(bs_rsv_gallery_styles_1.OpenPreviewButton, { "data-id": "open-preview-button", className: "open-preview", onClick: handleOpenOverlay },
                react_1.default.createElement(bs_rsv_gallery_styles_1.GalleryPreviewIcon, { name: previewIconName }),
                t('mediaGallery.openPreviewButton'))))));
    }, [previewIconName, handleOpenOverlay, items]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isOverlayShown ? null : (react_1.default.createElement(gallery_slider_1.GallerySlider, Object.assign({}, props, { leftArrow: isHideNavigation ? react_1.default.createElement(react_1.default.Fragment, null) : leftArrow, rightArrow: isHideNavigation ? react_1.default.createElement(react_1.default.Fragment, null) : rightArrow, items: items.map(getPreviewItem), initialSlide: initialSlide, onChangeSlide: (changedSlide, index) => setInitialSlide(index), renderItem: (item, i) => renderSlide(item, i, handleOpenOverlay, true) }), renderSlideInfo)),
        isOverlayShown && (react_1.default.createElement(bs_rsv_gallery_styles_1.MediaGalleryPreviewModal, { label: t('mediaGallery.previewLabel'), show: isOverlayShown, onClose: closeOverlay },
            react_1.default.createElement(gallery_slider_1.GallerySlider, { items: images, initialSlide: images[initialSlide] ? initialSlide : 0, isOverlay: true, onChangeSlide: changedSlide => {
                    setInitialSlide(changedSlide.mapIndex);
                    if (setCurrentItem) {
                        setCurrentItem(changedSlide);
                    }
                }, className: "lightbox-media-gallery", leftArrow: isHideNavigation ? react_1.default.createElement(react_1.default.Fragment, null) : leftArrow, rightArrow: isHideNavigation ? react_1.default.createElement(react_1.default.Fragment, null) : rightArrow, renderItem: (item, i) => renderSlide(item, i, handleOpenOverlay, false) }, overlaySlideInfo
                ? slide => images[slide]
                    ? overlaySlideInfo(images[slide], slide, images.length, isHideNavigation)
                    : null
                : null)))));
}
exports.BsRsvGallery = BsRsvGallery;
//# sourceMappingURL=bs-rsv-gallery.js.map